module.exports = "/assets/data/ac28adf4e62ea44968fee3711e787fe7-SS14.data.json";